import { useMemo } from 'react';
import { TravelInsuranceType } from '../../../../../../__generated__/graphql';
import Translations from './i18n';
import { ButtonToggle } from '$/components/ButtonToggle';
import { useClientContext } from '$/modules/context/client';
import { getClientTranslations } from '$/modules/i18n/client.index';

type CoverTypeToggleProps = {
  value: TravelInsuranceType;
  availableTripTypes: TravelInsuranceType[];
  onChange: (value: TravelInsuranceType) => void;
  onTooltipHover?: (label: string) => void;
};

export function CoverTypeToggle({
  value,
  availableTripTypes,
  onChange,
  onTooltipHover,
}: CoverTypeToggleProps): JSX.Element {
  const context = useClientContext();
  const staticText = getClientTranslations(Translations, context);

  const [options, mobileOptions] = useMemo<
    { value: TravelInsuranceType; label: string; disabled?: boolean }[][]
  >(
    () => [
      [
        {
          value: 'SINGLE_PLAN',
          label: staticText.options.SINGLE_PLAN,
          disabled: !availableTripTypes.includes('SINGLE_PLAN'),
        },
        {
          value: 'ANNUAL_PLAN',
          label: staticText.options.ANNUAL_PLAN,
          disabled: !availableTripTypes.includes('ANNUAL_PLAN'),
        },
      ],
      [
        {
          value: 'SINGLE_PLAN',
          label: staticText.optionsMobile.SINGLE_PLAN,
          disabled: !availableTripTypes.includes('SINGLE_PLAN'),
        },
        {
          value: 'ANNUAL_PLAN',
          label: staticText.optionsMobile.ANNUAL_PLAN,
          disabled: !availableTripTypes.includes('ANNUAL_PLAN'),
        },
      ],
    ],
    [staticText, availableTripTypes],
  );

  const coverageTypeTooltip =
    staticText?.coverageTypeTooltip[
      value as keyof typeof staticText.coverageTypeTooltip
    ];

  return (
    <>
      <ButtonToggle
        containerClassNames="md:flex hidden"
        options={options}
        value={value}
        onChange={onChange}
        label={staticText.title}
        labelTooltip={coverageTypeTooltip}
        onTooltipHover={
          onTooltipHover ? () => onTooltipHover(staticText.title) : undefined
        }
      />
      <ButtonToggle
        containerClassNames="flex md:hidden"
        options={mobileOptions}
        value={value}
        onChange={onChange}
        label={staticText.title}
        labelTooltip={coverageTypeTooltip}
        onTooltipHover={
          onTooltipHover ? () => onTooltipHover(staticText.title) : undefined
        }
      />
    </>
  );
}
